import { useRef, useState, useCallback, useMemo, useEffect } from 'react';
import { Spin, Select } from 'antd';
import * as convert from "../../constant/Convert.helper";
import axiosService from "../../../utils/axios.service";
import { format } from 'date-fns'
let _ = require('lodash');

export  const optionRating = [
  { value: 1, label: "1 sao" },
  { value: 2, label: '2 sao' },
  { value: 3, label: '3 sao' },
  { value: 4, label: '4 sao' },
  { value: 5, label: '5 sao' }
]

const PopupHistoryRating = (props) => {
    const [loading, setLoading] = useState(true)
    const [listHistory, setListHistory] = useState([])
    const [rating, setRating] = useState()
    const [description, setDescription] = useState("")

    useEffect(async () => {
        try {
            let res = await axiosService("api/history-rating/" + props.orderDetail.id, "GET")
            if (res.data.success == true) {
                setListHistory(res.data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false);
        }
    }, [])

    const changeRating = async () => {
        if (!rating || rating === props.orderDetail || description == "") return false
        let payload = {
            "new_rating": rating,
            "description": description,
            "order_id": props.orderDetail.id
        }
        setLoading(true)
        let res = await axiosService("api/history-rating/create", "POST", payload)

        if (res.data.success == true) {
            setListHistory(prev => [res.data.data, ...prev]);
            props.updateRating({id: props.orderDetail.id, rating:res.data.data.new_rating})
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    return (
        <div className="content-popup fadeInDown package-popup history-rating-popup">
            <div className="head-popup">
                <div className="title">Lịch sử đánh giá</div>
                <div className="close" onClick={() => props.setStatusDisplay(false)}>×</div>
            </div>
            <Spin spinning={loading} size="large" tip="Đang cập nhật">
                <div className="body-popup">
                    <div className="edit-rating">
                        <div className="d-flex">
                            <Select
                                className="select-rating"
                                optionFilterProp="children"
                                placeholder={"Chọn số sao"}
                                options={optionRating}
                                value={rating}
                                onChange={(e) => {setRating(e)}}
                            />
                            <div className="button-cent" onClick={changeRating}>
                                <span><i className="fas fa-save"></i></span>Sửa đánh giá
                            </div>
                        </div>
                        <textarea className="form-control text-rating" onChange={(e) => {setDescription(e.target.value)}} rows="5"  placeholder="Lý do sửa đánh giá"></textarea>
                    </div>
                    <div className="history-rating">
                        {listHistory.length > 0 ? 
                            <table className="table">
                                <thead className="hide-mobile">
                                    <tr>
                                        <th className="text-center">Trước khi sửa</th>
                                        <th className="text-center">Sau khi sửa</th>
                                        <th className="text-center">Lý do</th>
                                        <th className="text-center">Thời gian sửa</th>
                                        <th className="text-center">Người sửa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listHistory.map((val, key) => (
                                        <tr key={key} className="item-mobile-table">
                                            <td className="text-center mobile-table">
                                                <div className="title hide-desktop">Trước khi sửa</div>
                                                <div className="value">
                                                    {val.old_rating} Sao
                                                </div>
                                            </td>
                                            <td className="text-center mobile-table">
                                                <div className="title hide-desktop">Sau khi sửa</div>
                                                <div className="value">{val.new_rating} Sao</div>
                                            </td>
                                            <td className="text-center mobile-table" style={{width: "40%"}}>
                                                <div className="title hide-desktop">Lí do</div>
                                                <div className="value">{val.description}</div>
                                            </td>
                                            <td className="text-center mobile-table">
                                                <div className="title hide-desktop">Thời gian sửa</div>
                                                <div className="value">{format(new Date(val.created_at), "dd-MM-yyyy HH:mm:ss")}</div>
                                            </td>
                                            <td className="text-center mobile-table">
                                                <div className="title hide-desktop">Người sửa</div>
                                                {val?.user?.name || "--"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        : <div styles={{textAlign: "center"}}>Không có lịch sử chỉnh sửa</div>}
                    </div>
                </div>
            </Spin>
            
            <div className="bottom-popup">
                <div className="button-container">
                    <div className="button-cent" onClick={() => props.setStatusDisplay(false)}>
                        <span><i className="fas fa-save"></i></span>Đóng
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PopupHistoryRating;
